import { getApi } from "./api";
import type { AnalyticsProperties } from "./types";

export const trackAnalytics = (eventName: string, props: AnalyticsProperties) => getApi().trackAnalytics(`WEB_${eventName}`, props);
